import {
  FETCH_QUICK_CODES,
  FETCH_QUICK_CODES_START,
  FETCH_QUICK_CODES_SUCCESS,
  FETCH_QUICK_CODES_ERROR,
  SET_QUICK_CODES_PAGINATION,
  ADD_UPDATE_QUICK_CODE,
  ADD_UPDATE_QUICK_CODE_START,
  ADD_UPDATE_QUICK_CODE_SUCCESS,
  ADD_UPDATE_QUICK_CODE_ERROR,
  FETCH_QUICK_CODES_BY_ID,
  FETCH_FETCH_QUICK_CODES_BY_ID_START,
  FETCH_FETCH_QUICK_CODES_BY_ID_SUCCESS,
  FETCH_FETCH_QUICK_CODES_BY_ID_ERROR,
} from "../../actions/receptionist/quickCodesAction";
import { DELETE_QUICK_CODES_EXAMINATION,
    DELETE_QUICK_CODES_EXAMINATION_SUCCESS, 
    DELETE_QUICK_CODES_EXAMINATION_ERROR } from "../../actions/receptionist/visitsAction";
import _ from "lodash";

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    quickcodes: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
};

const quickCodesReducer = (state = INIT_STATE, action) => {
    let newState;
    let newVisits;
    let index;
    switch (action.type) {
        case FETCH_QUICK_CODES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_QUICK_CODES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, quickcodes: [...action.quickcodes] };

        }
        case FETCH_QUICK_CODES_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        case SET_QUICK_CODES_PAGINATION: {
            return { ...state, error: '', message: '', pagination: { ...action.pagination } };
        }

        case ADD_UPDATE_QUICK_CODE_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case ADD_UPDATE_QUICK_CODE_SUCCESS: {
            newState = _.cloneDeep(state);

            index = state.quickcodes.findIndex(quickcodeItem => quickcodeItem.quickCodeId === action.quickcodes.quickCodeId);
            if (index === -1) {
                newState.quickcodes.push(action.quickcodes);
            } else {
                newState.quickcodes[index] = _.cloneDeep(action.quickcodes);;
            }
            return { ...newState, loading: false };
        }

        case ADD_UPDATE_QUICK_CODE_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }

        case DELETE_QUICK_CODES_EXAMINATION_SUCCESS: {
            newState = _.cloneDeep(state);
            index = newState.quickcodes.findIndex(code => code.quickCodeId === action.data.quickCodeId);


            if (index === -1) {
                return newState;
            } else {

                let selectedQuickCode = newState.quickcodes[index];
                let selectedExaminations = [...selectedQuickCode.quickcodeItems];
                let modifiedExaminations = selectedExaminations.filter(examination => examination.quickCodeItemId !== action.data.quickCodeItemId)
                selectedQuickCode.quickCodeItems = [...modifiedExaminations];
                newState.quickcodes[index] = _.cloneDeep(selectedQuickCode);


                return newState;
            }

        }
        case DELETE_QUICK_CODES_EXAMINATION_ERROR: {
            return { ...state, error: '', message: '', loading: false };

        }

        default:
            return state;
    }
}

export default quickCodesReducer;
